import { Component, computed, inject } from '@angular/core';

import { ChdNavigationMenuPresenter } from '@cp-produkte/cruise-hospitality-design';

import { SpaRoute } from '@permission';

import { BackendToggleComponent } from '../backend-toggle/backend-toggle.component';
import { ComponentsModule } from '../components.module';

function toPath(routerLink: string | readonly string[]): string {
  return typeof routerLink === 'string' ? routerLink : routerLink.join('/');
}

/**
 * App-local renderer that draws `ChdNavigationMenu` with the SpaManager's existing
 * `spa-app-navigation`, unchanged. Plugged into the chd navigation-menu slot via the
 * backend provider, e.g. `provideChdDxBackend({ navigationMenu: ChdNavigationMenuSpaRenderer })`.
 *
 * Feature gap vs. the Material renderer: `spa-app-navigation` derives its own icons from
 * the route path and re-filters by permission internally, so `item.icon`, `item.label`,
 * `item.disabled`, `item.exactMatch` and collapse support are not forwarded.
 */
@Component({
  selector: 'spa-chd-navigation-menu-renderer',
  imports: [BackendToggleComponent, ComponentsModule],
  templateUrl: './chd-navigation-menu-spa-renderer.component.html',
  styleUrls: ['./chd-navigation-menu-spa-renderer.component.scss'],
})
export class ChdNavigationMenuSpaRenderer {
  protected readonly presenter = inject(ChdNavigationMenuPresenter);

  protected readonly routes = computed<SpaRoute[]>(() =>
    this.presenter.viewState().items.map((item) => ({ path: toPath(item.routerLink) })),
  );

  protected onLogout(): void {
    this.presenter.onLogout();
  }
}
